import React from 'react'
import delve from 'dlv'

import mapData from '../mapData'

const nodeWidth = 63
const nodeHeight = 57

const PersonNode = ({ node }) => {
  const nodeId = delve(node, 'nodeId')
  const nodeRatio = nodeWidth / nodeHeight

  // Media displayed on the map
  const mainMediaHeight = delve(node, 'media.data.0.attributes.height')
  const mainMediaWidth = delve(node, 'media.data.0.attributes.width')

  const pos = mapData[nodeId]

  if (pos) {
    return (
      <g
        transform={`translate(${pos.x - nodeWidth / 2} ${
          pos.y - nodeHeight / 2
        })`}
        width={nodeWidth}
        height={nodeHeight}
      >
        <g filter={`url(#filter-${nodeId})`}>
          <path
            d="M40.825 41H22.3642L13 25.1322L22.3642 9H40.825L50.1892 25.1322L40.825 41Z"
            fill={`url(#mediapattern-${nodeId})`}
          />
          <path
            d="M40.825 42.7297H41.8127L42.3147 41.8791L51.6789 26.0113L52.1934 25.1394L51.6852 24.2638L42.321 8.13164L41.821 7.27027H40.825H22.3642H21.3682L20.8682 8.13164L11.504 24.2638L10.9958 25.1394L11.5103 26.0113L20.8745 41.8791L21.3765 42.7297H22.3642H40.825Z"
            stroke="white"
            strokeWidth="3.45946"
          />
        </g>
        <defs>
          <filter
            id={`filter-${nodeId}`}
            x="0.34305"
            y="0.351338"
            width="62.5033"
            height="56.2162"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy="3.45946" />
            <feGaussianBlur stdDeviation="4.32432" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.783977 0 0 0 0 0.779844 0 0 0 0 0.8625 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow"
              result="shape"
            />
          </filter>
          <pattern
            id={`mediapattern-${nodeId}`}
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <image
              width={mainMediaWidth}
              height={mainMediaHeight}
              transform={`scale(${1 / mainMediaWidth} ${
                nodeRatio / mainMediaHeight
              })`}
              xlinkHref={`${delve(node, 'media.data.0.attributes.url')}`}
            />
          </pattern>
        </defs>
      </g>
    )
  } else {
    return <></>
  }
}

export default PersonNode
